package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Eritrea Flag (32x24dp)
 *
 * - ISO Alpha-2: ER
 * - ISO Alpha-3: ERI
 * - ISO Numeric: 232
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Eritrea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Eritrea:ER:ERI:232:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF43B764)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFB4D7F4)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 12f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFBE0027)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                lineTo(33f, 12f)
                lineTo(0f, 24f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF3E294)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.101f, 18.516f)
                curveTo(8.226f, 18.389f, 8.386f, 18.276f, 8.587f, 18.207f)
                curveTo(8.599f, 17.57f, 8.591f, 16.875f, 8.552f, 16.215f)
                curveTo(8.499f, 16.136f, 8.408f, 16.07f, 8.248f, 16.07f)
                curveTo(7.848f, 16.07f, 6.97f, 15.728f, 6.97f, 15.236f)
                curveTo(6.97f, 15.236f, 7.625f, 15.532f, 7.807f, 15.384f)
                curveTo(7.885f, 15.321f, 7.682f, 15.126f, 7.437f, 14.889f)
                curveTo(7.106f, 14.571f, 6.698f, 14.179f, 6.797f, 13.937f)
                curveTo(6.797f, 13.937f, 7.439f, 14.505f, 7.577f, 14.505f)
                curveTo(7.639f, 14.505f, 7.597f, 14.321f, 7.554f, 14.136f)
                curveTo(7.503f, 13.915f, 7.451f, 13.693f, 7.577f, 13.779f)
                curveTo(7.807f, 13.937f, 8.448f, 15.025f, 8.448f, 15.384f)
                curveTo(8.448f, 15.58f, 8.5f, 15.888f, 8.547f, 16.128f)
                lineTo(8.546f, 16.121f)
                curveTo(8.52f, 15.707f, 8.481f, 15.335f, 8.431f, 15.016f)
                curveTo(8.142f, 13.216f, 8.132f, 11.372f, 8.533f, 10.39f)
                curveTo(8.333f, 10.266f, 8.187f, 10.108f, 8.187f, 9.928f)
                curveTo(8.187f, 9.928f, 8.842f, 10.194f, 9.025f, 10.061f)
                curveTo(9.103f, 10.004f, 8.9f, 9.828f, 8.655f, 9.616f)
                curveTo(8.324f, 9.33f, 7.916f, 8.977f, 8.015f, 8.759f)
                curveTo(8.015f, 8.759f, 8.657f, 9.27f, 8.794f, 9.27f)
                curveTo(8.857f, 9.27f, 8.814f, 9.105f, 8.771f, 8.938f)
                curveTo(8.72f, 8.74f, 8.669f, 8.54f, 8.794f, 8.617f)
                curveTo(9.025f, 8.759f, 9.666f, 9.737f, 9.666f, 10.061f)
                lineTo(9.666f, 10.068f)
                curveTo(9.915f, 9.761f, 10.204f, 9.473f, 10.357f, 9.401f)
                curveTo(10.52f, 9.324f, 10.453f, 9.524f, 10.386f, 9.722f)
                curveTo(10.331f, 9.889f, 10.275f, 10.055f, 10.357f, 10.055f)
                curveTo(10.535f, 10.055f, 11.37f, 9.543f, 11.37f, 9.543f)
                curveTo(11.499f, 9.761f, 10.969f, 10.114f, 10.538f, 10.4f)
                curveTo(10.219f, 10.613f, 9.955f, 10.789f, 10.056f, 10.845f)
                curveTo(10.294f, 10.978f, 11.146f, 10.712f, 11.146f, 10.712f)
                curveTo(11.146f, 11.155f, 10.004f, 11.462f, 9.484f, 11.462f)
                curveTo(9.291f, 11.462f, 9.174f, 11.513f, 9.103f, 11.578f)
                curveTo(9.069f, 11.884f, 9.053f, 12.232f, 9.055f, 12.604f)
                curveTo(9.314f, 12.269f, 9.639f, 11.941f, 9.803f, 11.863f)
                curveTo(9.966f, 11.786f, 9.9f, 11.985f, 9.833f, 12.184f)
                curveTo(9.777f, 12.35f, 9.722f, 12.516f, 9.803f, 12.516f)
                curveTo(9.982f, 12.516f, 10.817f, 12.005f, 10.817f, 12.005f)
                curveTo(10.946f, 12.223f, 10.415f, 12.575f, 9.985f, 12.862f)
                curveTo(9.666f, 13.074f, 9.402f, 13.25f, 9.503f, 13.307f)
                curveTo(9.741f, 13.44f, 10.593f, 13.174f, 10.593f, 13.174f)
                curveTo(10.593f, 13.567f, 9.69f, 13.854f, 9.125f, 13.912f)
                curveTo(9.156f, 14.236f, 9.198f, 14.563f, 9.25f, 14.888f)
                curveTo(9.306f, 15.234f, 9.346f, 15.631f, 9.374f, 16.069f)
                curveTo(9.387f, 16.257f, 9.396f, 16.447f, 9.403f, 16.639f)
                curveTo(9.428f, 16.48f, 9.447f, 16.322f, 9.447f, 16.205f)
                curveTo(9.447f, 15.845f, 10.088f, 14.757f, 10.319f, 14.599f)
                curveTo(10.444f, 14.514f, 10.393f, 14.736f, 10.342f, 14.956f)
                curveTo(10.299f, 15.142f, 10.256f, 15.326f, 10.319f, 15.326f)
                curveTo(10.456f, 15.326f, 11.098f, 14.757f, 11.098f, 14.757f)
                curveTo(11.197f, 15f, 10.789f, 15.392f, 10.458f, 15.71f)
                curveTo(10.213f, 15.946f, 10.01f, 16.142f, 10.088f, 16.205f)
                curveTo(10.271f, 16.353f, 10.926f, 16.057f, 10.926f, 16.057f)
                curveTo(10.926f, 16.549f, 10.047f, 16.89f, 9.648f, 16.89f)
                curveTo(9.543f, 16.89f, 9.468f, 16.919f, 9.413f, 16.96f)
                curveTo(9.424f, 17.382f, 9.424f, 17.803f, 9.417f, 18.202f)
                curveTo(9.635f, 18.274f, 9.805f, 18.398f, 9.937f, 18.535f)
                curveTo(10.193f, 18.517f, 10.446f, 18.478f, 10.695f, 18.418f)
                curveTo(11.175f, 18.154f, 12.238f, 17.303f, 12.507f, 16.968f)
                curveTo(12.711f, 16.715f, 12.789f, 16.216f, 12.862f, 15.745f)
                lineTo(12.862f, 15.745f)
                curveTo(12.904f, 15.475f, 12.945f, 15.214f, 13.007f, 15.013f)
                curveTo(13.178f, 14.462f, 13.479f, 15.684f, 13.479f, 15.874f)
                curveTo(13.479f, 16.064f, 13.728f, 15.168f, 13.728f, 14.54f)
                curveTo(13.728f, 14.225f, 13.666f, 14.023f, 13.603f, 13.822f)
                curveTo(13.541f, 13.621f, 13.479f, 13.42f, 13.479f, 13.109f)
                curveTo(13.479f, 12.742f, 13.694f, 12.807f, 13.893f, 12.998f)
                curveTo(13.802f, 12.748f, 13.728f, 12.439f, 13.728f, 12.121f)
                curveTo(13.728f, 11.713f, 13.677f, 11.591f, 13.655f, 11.561f)
                curveTo(13.675f, 11.569f, 13.728f, 11.575f, 13.84f, 11.514f)
                curveTo(14.033f, 11.409f, 14.122f, 11.537f, 14.197f, 11.645f)
                curveTo(14.263f, 11.739f, 14.317f, 11.817f, 14.419f, 11.71f)
                curveTo(14.531f, 11.592f, 14.29f, 11.459f, 13.931f, 11.262f)
                curveTo(13.587f, 11.072f, 13.135f, 10.822f, 12.784f, 10.47f)
                curveTo(12.067f, 9.751f, 13.007f, 9.504f, 13.167f, 9.755f)
                curveTo(13.328f, 10.006f, 14.284f, 10.288f, 13.728f, 9.453f)
                curveTo(13.39f, 8.946f, 12.974f, 8.952f, 12.595f, 8.958f)
                curveTo(12.351f, 8.962f, 12.122f, 8.965f, 11.941f, 8.83f)
                curveTo(11.627f, 8.598f, 12.064f, 8.357f, 12.302f, 8.226f)
                curveTo(12.416f, 8.163f, 12.484f, 8.126f, 12.404f, 8.126f)
                curveTo(12.303f, 8.126f, 12.173f, 8.09f, 12.02f, 8.047f)
                curveTo(11.801f, 7.986f, 11.535f, 7.912f, 11.236f, 7.912f)
                curveTo(10.728f, 7.912f, 9.724f, 7.458f, 10.071f, 7.458f)
                curveTo(10.195f, 7.458f, 10.378f, 7.414f, 10.579f, 7.366f)
                curveTo(10.8f, 7.313f, 11.043f, 7.255f, 11.252f, 7.244f)
                curveTo(10.642f, 6.962f, 9.945f, 6.724f, 9.159f, 6.531f)
                lineTo(9.293f, 6f)
                curveTo(10.07f, 6.191f, 10.769f, 6.426f, 11.389f, 6.705f)
                curveTo(11.282f, 6.541f, 11.167f, 6.362f, 11.071f, 6.194f)
                curveTo(10.738f, 5.614f, 11.776f, 6.515f, 12.186f, 7.111f)
                lineTo(12.188f, 7.113f)
                curveTo(12.856f, 7.501f, 13.407f, 7.953f, 13.84f, 8.47f)
                verticalLineTo(7.296f)
                curveTo(14.228f, 7.429f, 14.449f, 8.683f, 14.565f, 9.627f)
                curveTo(14.65f, 9.817f, 14.722f, 10.013f, 14.784f, 10.215f)
                curveTo(14.935f, 9.812f, 15.22f, 9.385f, 15.476f, 9.755f)
                curveTo(15.781f, 10.196f, 15.242f, 12.696f, 15.044f, 13.56f)
                curveTo(15.035f, 13.651f, 15.025f, 13.741f, 15.014f, 13.83f)
                curveTo(15.487f, 13.529f, 15.732f, 12.834f, 15.858f, 12.477f)
                curveTo(15.966f, 12.17f, 15.985f, 12.115f, 15.985f, 12.783f)
                curveTo(15.985f, 13.646f, 15.313f, 14.501f, 14.763f, 15.057f)
                curveTo(14.684f, 15.33f, 14.59f, 15.596f, 14.482f, 15.855f)
                curveTo(14.862f, 15.735f, 15.187f, 15.525f, 15.439f, 15.362f)
                curveTo(15.88f, 15.076f, 16.096f, 14.936f, 15.985f, 15.684f)
                curveTo(15.864f, 16.498f, 14.682f, 16.799f, 13.939f, 16.908f)
                curveTo(13.885f, 16.995f, 13.829f, 17.08f, 13.771f, 17.165f)
                lineTo(13.74f, 17.203f)
                curveTo(13.625f, 17.32f, 13.509f, 17.431f, 13.391f, 17.537f)
                curveTo(13.466f, 17.505f, 13.538f, 17.472f, 13.609f, 17.44f)
                curveTo(13.899f, 17.308f, 14.163f, 17.188f, 14.497f, 17.188f)
                curveTo(14.699f, 17.188f, 14.423f, 17.294f, 14.033f, 17.443f)
                lineTo(14.033f, 17.443f)
                lineTo(14.033f, 17.443f)
                lineTo(14.033f, 17.443f)
                curveTo(13.571f, 17.619f, 12.949f, 17.857f, 12.767f, 18.054f)
                curveTo(12.691f, 18.136f, 12.641f, 18.203f, 12.6f, 18.257f)
                curveTo(12.481f, 18.415f, 12.445f, 18.463f, 12.071f, 18.473f)
                curveTo(11.495f, 18.779f, 10.894f, 18.973f, 10.269f, 19.052f)
                curveTo(10.309f, 19.146f, 10.325f, 19.207f, 10.325f, 19.207f)
                horizontalLineTo(7.693f)
                curveTo(7.693f, 19.207f, 7.714f, 19.132f, 7.763f, 19.02f)
                curveTo(7.216f, 18.927f, 6.687f, 18.745f, 6.177f, 18.475f)
                curveTo(6.163f, 18.475f, 6.149f, 18.475f, 6.135f, 18.475f)
                curveTo(5.564f, 18.475f, 5.538f, 18.44f, 5.4f, 18.257f)
                lineTo(5.4f, 18.257f)
                lineTo(5.4f, 18.257f)
                curveTo(5.359f, 18.203f, 5.309f, 18.136f, 5.233f, 18.054f)
                curveTo(5.051f, 17.857f, 4.429f, 17.619f, 3.967f, 17.443f)
                lineTo(3.967f, 17.443f)
                curveTo(3.577f, 17.294f, 3.301f, 17.188f, 3.503f, 17.188f)
                curveTo(3.837f, 17.188f, 4.101f, 17.308f, 4.391f, 17.44f)
                curveTo(4.483f, 17.482f, 4.578f, 17.525f, 4.678f, 17.565f)
                curveTo(4.773f, 17.604f, 4.899f, 17.65f, 5.039f, 17.698f)
                curveTo(4.858f, 17.546f, 4.68f, 17.381f, 4.505f, 17.203f)
                lineTo(4.473f, 17.165f)
                curveTo(4.423f, 17.091f, 4.373f, 17.016f, 4.326f, 16.94f)
                curveTo(3.638f, 16.865f, 2.164f, 16.598f, 2.029f, 15.684f)
                curveTo(1.918f, 14.936f, 2.134f, 15.076f, 2.575f, 15.362f)
                curveTo(2.841f, 15.534f, 3.188f, 15.758f, 3.595f, 15.874f)
                curveTo(3.669f, 15.895f, 3.734f, 15.912f, 3.792f, 15.926f)
                curveTo(3.714f, 15.743f, 3.643f, 15.558f, 3.579f, 15.368f)
                curveTo(3.018f, 14.865f, 2.029f, 13.83f, 2.029f, 12.783f)
                curveTo(2.029f, 12.115f, 2.048f, 12.17f, 2.157f, 12.477f)
                curveTo(2.286f, 12.844f, 2.541f, 13.567f, 3.04f, 13.854f)
                curveTo(3.04f, 13.854f, 2.168f, 10.29f, 2.538f, 9.755f)
                curveTo(2.908f, 9.22f, 3.338f, 10.348f, 3.338f, 10.666f)
                curveTo(3.338f, 10.721f, 3.343f, 10.661f, 3.356f, 10.524f)
                lineTo(3.356f, 10.524f)
                lineTo(3.356f, 10.524f)
                lineTo(3.356f, 10.524f)
                curveTo(3.414f, 9.873f, 3.63f, 7.483f, 4.174f, 7.296f)
                verticalLineTo(8.588f)
                curveTo(4.174f, 8.649f, 4.201f, 8.672f, 4.248f, 8.666f)
                curveTo(4.61f, 8.188f, 5.067f, 7.762f, 5.618f, 7.388f)
                curveTo(5.7f, 7.287f, 5.772f, 7.193f, 5.828f, 7.111f)
                curveTo(6.238f, 6.515f, 7.276f, 5.614f, 6.944f, 6.194f)
                curveTo(6.844f, 6.368f, 6.724f, 6.552f, 6.614f, 6.721f)
                lineTo(6.614f, 6.721f)
                lineTo(6.614f, 6.722f)
                curveTo(6.582f, 6.77f, 6.552f, 6.817f, 6.523f, 6.862f)
                curveTo(7.223f, 6.514f, 8.033f, 6.226f, 8.951f, 6f)
                lineTo(9.085f, 6.531f)
                curveTo(8.281f, 6.729f, 7.57f, 6.973f, 6.95f, 7.264f)
                curveTo(7.109f, 7.288f, 7.278f, 7.328f, 7.435f, 7.366f)
                lineTo(7.435f, 7.366f)
                curveTo(7.636f, 7.414f, 7.819f, 7.458f, 7.943f, 7.458f)
                curveTo(8.29f, 7.458f, 7.286f, 7.912f, 6.778f, 7.912f)
                curveTo(6.479f, 7.912f, 6.213f, 7.986f, 5.994f, 8.047f)
                curveTo(5.841f, 8.09f, 5.711f, 8.126f, 5.61f, 8.126f)
                curveTo(5.53f, 8.126f, 5.598f, 8.163f, 5.712f, 8.226f)
                curveTo(5.95f, 8.357f, 6.388f, 8.598f, 6.074f, 8.83f)
                curveTo(5.892f, 8.965f, 5.663f, 8.962f, 5.419f, 8.958f)
                curveTo(5.148f, 8.954f, 4.858f, 8.95f, 4.592f, 9.132f)
                curveTo(4.412f, 9.39f, 4.263f, 9.662f, 4.143f, 9.95f)
                curveTo(4.264f, 10.109f, 4.738f, 9.925f, 4.847f, 9.755f)
                curveTo(5.007f, 9.504f, 5.948f, 9.751f, 5.23f, 10.47f)
                curveTo(4.879f, 10.822f, 4.427f, 11.072f, 4.083f, 11.262f)
                curveTo(3.971f, 11.323f, 3.87f, 11.379f, 3.788f, 11.43f)
                curveTo(3.776f, 11.528f, 3.766f, 11.626f, 3.757f, 11.723f)
                curveTo(3.777f, 11.702f, 3.796f, 11.674f, 3.817f, 11.645f)
                curveTo(3.892f, 11.537f, 3.981f, 11.409f, 4.174f, 11.514f)
                curveTo(4.286f, 11.575f, 4.339f, 11.569f, 4.359f, 11.561f)
                curveTo(4.337f, 11.591f, 4.286f, 11.713f, 4.286f, 12.121f)
                curveTo(4.286f, 12.439f, 4.212f, 12.748f, 4.121f, 12.998f)
                curveTo(4.32f, 12.807f, 4.535f, 12.742f, 4.535f, 13.109f)
                curveTo(4.535f, 13.42f, 4.473f, 13.621f, 4.411f, 13.822f)
                curveTo(4.348f, 14.023f, 4.286f, 14.225f, 4.286f, 14.54f)
                curveTo(4.286f, 15.168f, 4.535f, 16.064f, 4.535f, 15.874f)
                curveTo(4.535f, 15.684f, 4.836f, 14.462f, 5.007f, 15.013f)
                curveTo(5.069f, 15.214f, 5.11f, 15.475f, 5.152f, 15.745f)
                curveTo(5.225f, 16.216f, 5.303f, 16.715f, 5.507f, 16.968f)
                curveTo(5.741f, 17.259f, 6.571f, 17.938f, 7.101f, 18.285f)
                curveTo(7.427f, 18.4f, 7.76f, 18.477f, 8.101f, 18.516f)
                close()
                moveTo(4.369f, 11.552f)
                curveTo(4.369f, 11.551f, 4.365f, 11.553f, 4.359f, 11.561f)
                curveTo(4.367f, 11.557f, 4.37f, 11.553f, 4.369f, 11.552f)
                close()
                moveTo(13.655f, 11.561f)
                curveTo(13.649f, 11.553f, 13.645f, 11.551f, 13.645f, 11.552f)
                curveTo(13.644f, 11.553f, 13.647f, 11.557f, 13.655f, 11.561f)
                close()
                moveTo(13.834f, 15.953f)
                curveTo(13.856f, 15.906f, 13.878f, 15.859f, 13.899f, 15.812f)
                curveTo(13.844f, 15.866f, 13.802f, 15.924f, 13.834f, 15.953f)
                close()
                moveTo(9.217f, 10.949f)
                curveTo(9.203f, 11.084f, 9.166f, 11.249f, 9.126f, 11.4f)
                curveTo(9.15f, 11.234f, 9.18f, 11.083f, 9.217f, 10.949f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun EritreaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Eritrea,
            contentDescription = "Eritrea Flag"
        )
    }
}
